var _g, _defs;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgCustom(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 545,
    height: 708,
    viewBox: "0 0 545 708",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M399.055 100H173.14C156.578 100 143.152 113.409 143.152 129.95V301.299C140.822 302.122 139.153 304.34 139.153 306.949V338.895C139.153 341.503 140.822 343.722 143.152 344.544V603.441C143.152 619.982 156.578 633.391 173.14 633.391H399.055C415.617 633.391 429.043 619.982 429.043 603.441V257.735C432.356 257.735 435.041 255.053 435.041 251.745V181.863C435.041 178.554 432.356 175.873 429.043 175.873V129.95C429.043 113.409 415.617 100 399.055 100Z",
    fill: "#0C2C54"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M395.057 111.98H179.138C165.889 111.98 155.147 122.707 155.147 135.94V599.448C155.147 612.68 165.889 623.408 179.138 623.408H395.057C408.306 623.408 419.047 612.68 419.047 599.448V135.94C419.047 122.707 408.306 111.98 395.057 111.98Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M391.257 280H233.743C230.571 280 228 282.239 228 285C228 287.761 230.571 290 233.743 290H391.257C394.429 290 397 287.761 397 285C397 282.239 394.429 280 391.257 280Z",
    fill: "#DDE9F8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M269.593 261H232.159C229.862 261 228 262.862 228 265.159C228 267.456 229.862 269.319 232.159 269.319H269.593C271.89 269.319 273.752 267.456 273.752 265.159C273.752 262.862 271.89 261 269.593 261Z",
    fill: "#DDE9F8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M193 254C197.153 254 201.214 255.232 204.667 257.539C208.12 259.847 210.812 263.126 212.401 266.964C213.991 270.801 214.407 275.023 213.596 279.097C212.786 283.17 210.786 286.912 207.849 289.849C204.912 292.786 201.17 294.786 197.097 295.596C193.023 296.407 188.801 295.991 184.964 294.401C181.126 292.812 177.847 290.12 175.539 286.667C173.232 283.214 172 279.153 172 275C172 269.43 174.212 264.089 178.151 260.151C182.089 256.212 187.43 254 193 254Z",
    fill: "#BEDBFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M391.257 342H233.743C230.571 342 228 344.239 228 347C228 349.761 230.571 352 233.743 352H391.257C394.429 352 397 349.761 397 347C397 344.239 394.429 342 391.257 342Z",
    fill: "#DDE9F8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M269.593 323H232.159C229.862 323 228 324.862 228 327.159C228 329.456 229.862 331.319 232.159 331.319H269.593C271.89 331.319 273.752 329.456 273.752 327.159C273.752 324.862 271.89 323 269.593 323Z",
    fill: "#DDE9F8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M193 316C197.153 316 201.214 317.232 204.667 319.539C208.12 321.847 210.812 325.126 212.401 328.964C213.991 332.801 214.407 337.023 213.596 341.097C212.786 345.17 210.786 348.912 207.849 351.849C204.912 354.786 201.17 356.786 197.097 357.596C193.023 358.407 188.801 357.991 184.964 356.401C181.126 354.812 177.847 352.12 175.539 348.667C173.232 345.214 172 341.153 172 337C172 331.43 174.212 326.089 178.151 322.151C182.089 318.212 187.43 316 193 316Z",
    fill: "#BEDBFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M391.257 404H233.743C230.571 404 228 406.239 228 409C228 411.761 230.571 414 233.743 414H391.257C394.429 414 397 411.761 397 409C397 406.239 394.429 404 391.257 404Z",
    fill: "#DDE9F8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M269.593 385H232.159C229.862 385 228 386.862 228 389.159C228 391.456 229.862 393.319 232.159 393.319H269.593C271.89 393.319 273.752 391.456 273.752 389.159C273.752 386.862 271.89 385 269.593 385Z",
    fill: "#DDE9F8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M193 378C197.153 378 201.214 379.232 204.667 381.539C208.12 383.847 210.812 387.126 212.401 390.964C213.991 394.801 214.407 399.023 213.596 403.097C212.786 407.17 210.786 410.912 207.849 413.849C204.912 416.786 201.17 418.786 197.097 419.596C193.023 420.407 188.801 419.991 184.964 418.401C181.126 416.812 177.847 414.12 175.539 410.667C173.232 407.214 172 403.153 172 399C172 393.43 174.212 388.089 178.151 384.151C182.089 380.212 187.43 378 193 378Z",
    fill: "#BEDBFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M391.257 466H233.743C230.571 466 228 468.239 228 471C228 473.761 230.571 476 233.743 476H391.257C394.429 476 397 473.761 397 471C397 468.239 394.429 466 391.257 466Z",
    fill: "#DDE9F8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M269.593 447H232.159C229.862 447 228 448.862 228 451.159C228 453.456 229.862 455.319 232.159 455.319H269.593C271.89 455.319 273.752 453.456 273.752 451.159C273.752 448.862 271.89 447 269.593 447Z",
    fill: "#DDE9F8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M193 440C197.153 440 201.214 441.232 204.667 443.539C208.12 445.847 210.812 449.126 212.401 452.964C213.991 456.801 214.407 461.023 213.596 465.097C212.786 469.17 210.786 472.912 207.849 475.849C204.912 478.786 201.17 480.786 197.097 481.596C193.023 482.407 188.801 481.991 184.964 480.401C181.126 478.812 177.847 476.12 175.539 472.667C173.232 469.214 172 465.153 172 461C172 455.43 174.212 450.089 178.151 446.151C182.089 442.212 187.43 440 193 440Z",
    fill: "#BEDBFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M391.257 528H233.743C230.571 528 228 530.239 228 533C228 535.761 230.571 538 233.743 538H391.257C394.429 538 397 535.761 397 533C397 530.239 394.429 528 391.257 528Z",
    fill: "#DDE9F8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M269.593 509H232.159C229.862 509 228 510.862 228 513.159C228 515.456 229.862 517.319 232.159 517.319H269.593C271.89 517.319 273.752 515.456 273.752 513.159C273.752 510.862 271.89 509 269.593 509Z",
    fill: "#DDE9F8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M193 502C197.153 502 201.214 503.232 204.667 505.539C208.12 507.847 210.812 511.126 212.401 514.964C213.991 518.801 214.407 523.023 213.596 527.097C212.786 531.17 210.786 534.912 207.849 537.849C204.912 540.786 201.17 542.786 197.097 543.596C193.023 544.407 188.801 543.991 184.964 542.401C181.126 540.812 177.847 538.12 175.539 534.667C173.232 531.214 172 527.153 172 523C172 517.43 174.212 512.089 178.151 508.151C182.089 504.212 187.43 502 193 502Z",
    fill: "#BEDBFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M391.257 590H233.743C230.571 590 228 592.239 228 595C228 597.761 230.571 600 233.743 600H391.257C394.429 600 397 597.761 397 595C397 592.239 394.429 590 391.257 590Z",
    fill: "#DDE9F8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M269.593 571H232.159C229.862 571 228 572.862 228 575.159C228 577.456 229.862 579.319 232.159 579.319H269.593C271.89 579.319 273.752 577.456 273.752 575.159C273.752 572.862 271.89 571 269.593 571Z",
    fill: "#DDE9F8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M193 564C197.153 564 201.214 565.232 204.667 567.539C208.12 569.847 210.812 573.126 212.401 576.964C213.991 580.801 214.407 585.023 213.596 589.097C212.786 593.17 210.786 596.912 207.849 599.849C204.912 602.786 201.17 604.786 197.097 605.596C193.023 606.407 188.801 605.991 184.964 604.401C181.126 602.812 177.847 600.12 175.539 596.667C173.232 593.214 172 589.153 172 585C172 579.43 174.212 574.089 178.151 570.151C182.089 566.212 187.43 564 193 564Z",
    fill: "#BEDBFF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M397.056 111.98H177.139C171.306 111.98 165.713 114.625 161.589 119.332C157.481 124.02 155.166 130.372 155.147 137H155V192H419V137.081H419.047C419.047 130.424 416.73 124.039 412.606 119.332C408.482 114.625 402.888 111.98 397.056 111.98Z",
    fill: "#D3E5FC"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 172,
    y: 213,
    width: 62,
    height: 20,
    rx: 10,
    fill: "#DDE9F8"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 338,
    y: 213,
    width: 52,
    height: 20,
    rx: 10,
    fill: "#DDE9F8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M400 223C400 217.477 404.477 213 410 213H419V233H410C404.477 233 400 228.523 400 223Z",
    fill: "#DDE9F8"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 244,
    y: 213,
    width: 84,
    height: 20,
    rx: 10,
    fill: "#DDE9F8"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 181.5,
    cy: 169.5,
    r: 9.5,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 264.5,
    cy: 169.5,
    r: 9.5,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 347.5,
    cy: 169.5,
    r: 9.5,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 213,
    y: 160,
    width: 20,
    height: 20,
    rx: 5,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 296,
    y: 160,
    width: 20,
    height: 20,
    rx: 5,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 379,
    y: 160,
    width: 20,
    height: 20,
    rx: 5,
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M410.477 282.493C402.986 282.493 395.722 281.007 388.883 278.074C382.278 275.242 376.344 271.185 371.249 266.02C366.153 260.853 362.152 254.838 359.358 248.141C356.466 241.206 355 233.842 355 226.248C355 218.653 356.466 211.288 359.358 204.354C362.153 197.657 366.153 191.64 371.249 186.475C376.344 181.308 382.278 177.251 388.883 174.419C395.72 171.486 402.985 170 410.477 170C417.967 170 425.232 171.486 432.07 174.419C438.674 177.253 444.608 181.308 449.704 186.475C454.799 191.64 458.8 197.657 461.593 204.354C464.486 211.288 465.952 218.651 465.952 226.248C465.952 233.842 464.486 241.207 461.593 248.141C458.8 254.837 454.799 260.853 449.704 266.02C444.608 271.185 438.676 275.242 432.07 278.074C425.23 281.007 417.967 282.493 410.477 282.493Z",
    fill: "#5C7DA6"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_d)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M424.748 209.703L418.603 206.924L424.748 204.144L427.527 198L430.306 204.144L436.45 206.924L430.306 209.703L427.527 215.847L424.748 209.703ZM434.615 225.331L432.626 220.946L430.637 225.331L426.252 227.32L430.637 229.309L432.626 233.694L434.615 229.309L439 227.32L434.615 225.331ZM421.765 229.538L425.305 232.22C426.108 232.829 426.333 233.941 425.829 234.814L421.218 242.8C420.715 243.672 419.641 244.034 418.712 243.644L414.626 241.929C414.116 242.261 413.555 242.592 412.994 242.873L412.448 247.24C412.323 248.24 411.473 248.992 410.464 248.992H401.248C400.239 248.992 399.388 248.24 399.263 247.239L398.717 242.847C398.156 242.567 397.62 242.261 397.085 241.904L392.999 243.618C392.07 244.008 390.996 243.646 390.493 242.774L385.882 234.789C385.378 233.916 385.603 232.804 386.407 232.195L389.946 229.513C389.921 229.232 389.921 228.901 389.921 228.595C389.921 228.289 389.921 227.958 389.946 227.652L386.407 224.969C385.603 224.361 385.378 223.249 385.882 222.375L390.493 214.39C390.996 213.518 392.07 213.156 392.999 213.546L397.085 215.261C397.595 214.929 398.156 214.598 398.717 214.317L399.263 209.95C399.388 208.949 400.239 208.198 401.247 208.198H410.463C411.472 208.198 412.323 208.95 412.448 209.951L412.994 214.343C413.555 214.623 414.091 214.929 414.626 215.286L418.712 213.571C419.641 213.182 420.715 213.543 421.218 214.416L425.829 222.401C426.333 223.274 426.108 224.386 425.305 224.995L421.765 227.677C421.79 227.983 421.79 228.289 421.79 228.62C421.79 228.952 421.79 229.232 421.765 229.538ZM413.504 228.595C413.504 224.363 410.088 220.946 405.856 220.946C401.623 220.946 398.207 224.363 398.207 228.595C398.207 232.827 401.623 236.244 405.856 236.244C410.088 236.244 413.504 232.827 413.504 228.595Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M363.917 484C382.097 484 399.868 489.384 414.984 499.471C430.099 509.558 441.881 523.895 448.838 540.668C455.795 557.442 457.615 575.9 454.068 593.707C450.521 611.514 441.767 627.871 428.912 640.709C416.058 653.547 399.679 662.29 381.849 665.832C364.019 669.374 345.538 667.556 328.742 660.608C311.946 653.66 297.591 641.894 287.491 626.798C277.391 611.702 272 593.954 272 575.798C272 551.452 281.684 528.102 298.922 510.887C316.16 493.672 339.539 484 363.917 484V484Z",
    fill: "#177FFF"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_d)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M394.791 569.885C397.63 570.383 400.277 570.588 402.759 571.332C406.874 572.575 410.433 575.207 412.831 578.783C415.23 582.359 416.321 586.657 415.918 590.948C415.459 595.194 413.584 599.159 410.596 602.202C407.608 605.244 403.683 607.185 399.458 607.709C397.997 607.887 396.527 607.98 395.056 607.986C375.636 608.005 356.216 608.005 336.799 607.986C331.062 607.986 325.713 606.62 321.219 602.946C313.659 596.772 310.473 588.749 312.693 579.166C314.963 569.38 321.339 563.263 331.216 561.414C334.386 560.82 336.198 559.655 337.837 556.822C344.298 545.692 356.56 540.899 367.472 542.211C373.847 542.934 379.835 545.641 384.597 549.952C389.359 554.264 392.655 559.963 394.021 566.25C394.294 567.5 394.556 568.754 394.791 569.885ZM362.058 575.693H361.985C361.985 566.568 361.985 557.442 361.985 548.316C361.985 545.97 361.985 545.939 359.573 546.271C358.18 546.428 356.8 546.686 355.444 547.043C347.822 549.266 342.747 554.506 339.146 561.322C338.272 562.973 335.383 563.749 335.383 563.749C335.383 563.749 333.101 563.996 331.989 564.27C326.707 565.562 322.129 568.857 319.216 573.462C316.303 578.067 315.282 583.625 316.368 588.969C318.184 598.157 325.81 604.243 335.163 604.725C343.217 605.142 351.3 604.953 359.369 604.949C361.466 604.949 362.062 604.208 362.062 602.062C362.078 592.944 362.079 584.821 362.066 575.693H362.058Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M139.158 323C150.463 323 161.514 326.348 170.914 332.62C180.313 338.893 187.64 347.808 191.966 358.239C196.292 368.67 197.424 380.148 195.218 391.221C193.013 402.294 187.569 412.465 179.575 420.449C171.582 428.432 161.397 433.869 150.309 436.072C139.222 438.274 127.729 437.144 117.285 432.823C106.84 428.503 97.9136 421.186 91.6329 411.798C85.3523 402.411 82 391.374 82 380.084C82 364.945 88.022 350.425 98.7413 339.72C109.461 329.014 123.999 323 139.158 323V323Z",
    fill: "#A966FF"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter3_d)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M140.511 368.672H128.418C125.637 368.623 122.936 369.606 120.837 371.431C118.738 373.256 117.39 375.794 117.052 378.555C116.769 381.452 117.646 384.344 119.492 386.595C121.337 388.847 124.001 390.274 126.898 390.564C126.982 390.574 127.066 390.582 127.151 390.588L129.445 396.053C129.833 396.977 130.486 397.765 131.321 398.319C132.156 398.873 133.136 399.168 134.138 399.167C135.489 399.165 136.784 398.628 137.739 397.673C138.694 396.718 139.232 395.423 139.233 394.072V390.61H140.515L140.511 368.672Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter4_d)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M160.062 364.091C159.011 362.545 157.389 361.479 155.553 361.126C153.716 360.774 151.815 361.165 150.266 362.213L143.652 366.692V392.577L150.296 397.033C151.46 397.813 152.831 398.229 154.232 398.227C154.825 398.228 155.416 398.156 155.992 398.011C157.532 397.589 158.888 396.665 159.846 395.387C160.804 394.109 161.309 392.548 161.282 390.951V368.048C161.283 366.636 160.858 365.257 160.062 364.091Z",
    fill: "white"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d",
    x: 0,
    y: 0,
    width: 523.952,
    height: 707.596,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -12,
    dy: -30
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 35
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.0666667 0 0 0 0 0.2 0 0 0 0 0.4 0 0 0 0.2 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d",
    x: 375.614,
    y: 192,
    width: 73.3857,
    height: 70.9915,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_d",
    x: 302,
    y: 536,
    width: 124,
    height: 86,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter3_d",
    x: 111,
    y: 365.671,
    width: 35.5149,
    height: 42.4962,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 3
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.161 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter4_d",
    x: 137.652,
    y: 358,
    width: 29.6311,
    height: 49.2274,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 3
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.161 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow",
    result: "shape"
  })))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCustom);
export default __webpack_public_path__ + "static/media/Custom.1d127ee8fb3338affc2843abbad1dd7d.svg";
export { ForwardRef as ReactComponent };